import React from 'react';
import Image from 'next/image';
import { IMembershipCard } from '@/shared/types/existing-brands';
import './index.less';

const MembershipCard = ({ title, image: { width, height, link }, description }: IMembershipCard) => {
  return (
    <div className="membership-card-container">
      <div className="header">
        <p className="title">{title}</p>
        <p className="description">{description}</p>
      </div>
      <div className="image">
        <Image width={width} height={height} src={link} alt={title} />
      </div>
    </div>
  );
};

export default MembershipCard;
